import { render, staticRenderFns } from "./exportStudent.vue?vue&type=template&id=4aa5ba8c&"
import script from "./exportStudent.vue?vue&type=script&lang=js&"
export * from "./exportStudent.vue?vue&type=script&lang=js&"
import style0 from "./exportStudent.vue?vue&type=style&index=0&id=4aa5ba8c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports